const _excluded = ["count", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import { Typography } from 'seagull';
import styles from "./index.module.scss";
export default function TabPimple(_ref) {
  let {
      count,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (isNaN(count) || 0 >= count) return null;
  const content = count >= 9 ? '9+' : String(count);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.root, className)
  }, props), /*#__PURE__*/React.createElement(Typography, {
    skin: "invertedStandard",
    as: "span",
    className: styles.pimple,
    "aria-label": "".concat(content, " notifications"),
    "data-testid": "pimple"
  }, content));
}